module.exports = __webpack_public_path__ + "img/pinterest.2283db3e.jpg";